import { KindResultDecisionCodesEnum } from 'APIPackage/CatalogsModule/enums/KindResultDecisionCodesEnum';
import { IDecision } from 'APIPackage/DecisionModule/interfaces/IDecision';
import { fetchDecisionById } from 'APIPackage/DecisionModule/services/decisionApi';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IKnmLink } from 'APIPackage/KnmModule/interfaces/IKnmLink';
import { fetchKnm } from 'APIPackage/KnmModule/services/knmApi';
import { ROUTE_DECISION, ROUTE_KNM, ROUTE_PM } from 'CorePackage/MainModule/routes/routes';
import { getMatchedViolation } from 'KnmErknmPackage/ErknmEventSubjectModule/functions/getMatchedViolation';

export const getViolationsByReasonLink = async (
  isEnablePrescriptionCheck: boolean,
  isPrescriptionCheck: boolean,
  link: IKnmLink | undefined,
) => {
  if (isEnablePrescriptionCheck && isPrescriptionCheck && link) {
    // Делаем запрос на получение паспорта по ссылке, чтобы получить и заполнить нарушения
    if (link.knmType === 'Decision') {
      const decisionData: IDecision = await fetchDecisionById(link.id);
      const prescriptions =
        decisionData.organization?.decisions?.filter(
          i => i.kind?.code === KindResultDecisionCodesEnum.D_1 || i.kind?.code === KindResultDecisionCodesEnum.D_7,
        ) || [];

      return getMatchedViolation(prescriptions, `${ROUTE_DECISION(decisionData.id)}`);
    }

    const knmData: IKnm = await fetchKnm(link.id);

    if (knmData.pmErknm) {
      const prescriptions =
        knmData.pmErknm.subject?.pmResultDecisions?.filter(
          i =>
            i.kindDecision?.code === KindResultDecisionCodesEnum.D_1 ||
            i.kindDecision?.code === KindResultDecisionCodesEnum.D_7,
        ) || [];

      return getMatchedViolation(prescriptions, `${ROUTE_PM(knmData.id)}`);
    }

    if (knmData.knmErknm) {
      const prescriptions =
        knmData?.knmErknm?.organizations?.[0]?.resultDecisions?.filter(
          i =>
            i.kindDecision?.code === KindResultDecisionCodesEnum.D_1 ||
            i.kindDecision?.code === KindResultDecisionCodesEnum.D_7,
        ) || [];

      return getMatchedViolation(prescriptions, `${ROUTE_KNM(knmData.id)}`);
    }
  }
};
